import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialPlatforms = [
    { 
      name: 'Facebook', 
      icon: 'fab fa-facebook-f', 
      url: 'https://facebook.com',
      color: '#1877F2'
    },
    { 
      name: 'Twitter', 
      icon: 'fab fa-twitter', 
      url: 'https://twitter.com',
      color: '#1DA1F2'
    },
    { 
      name: 'Instagram', 
      icon: 'fab fa-instagram', 
      url: 'https://instagram.com',
      color: '#E4405F'
    },
    { 
      name: 'YouTube', 
      icon: 'fab fa-youtube', 
      url: 'https://youtube.com',
      color: '#FF0000'
    },
    { 
      name: 'LinkedIn', 
      icon: 'fab fa-linkedin-in', 
      url: 'https://linkedin.com',
      color: '#0A66C2'
    }
  ];

  const handleSocialClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <footer className="bg-dark text-white py-5 mt-auto">
      <Container>
        <Row>
          <Col lg={4} className="mb-4">
            <h4 className="text-warning mb-4">
              <i className="fas fa-graduation-cap me-2"></i>
              University College
            </h4>
            <p className="text-white-50">
              Committed to excellence in education, research, and innovation 
              since 1990. Nurturing future leaders for a better tomorrow.
            </p>
            <div className="social-links mt-4">
              <div className="d-flex gap-2">
                {socialPlatforms.map((platform) => (
                  <Button
                    key={platform.name}
                    variant="outline-light"
                    size="sm"
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{ 
                      width: '40px', 
                      height: '40px',
                      borderColor: platform.color,
                      color: platform.color
                    }}
                    onClick={() => handleSocialClick(platform.url)}
                    aria-label={`Follow us on ${platform.name}`}
                    title={`Follow us on ${platform.name}`}
                  >
                    <i className={platform.icon}></i>
                  </Button>
                ))}
              </div>
            </div>
          </Col>
          
          <Col lg={2} md={4} className="mb-4">
            <h5 className="text-white mb-4">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/" className="text-white-50 text-decoration-none">
                  <i className="fas fa-chevron-right me-2 text-warning"></i>
                  Home
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/about" className="text-white-50 text-decoration-none">
                  <i className="fas fa-chevron-right me-2 text-warning"></i>
                  About Us
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/departments" className="text-white-50 text-decoration-none">
                  <i className="fas fa-chevron-right me-2 text-warning"></i>
                  Departments
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/courses" className="text-white-50 text-decoration-none">
                  <i className="fas fa-chevron-right me-2 text-warning"></i>
                  Courses
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/contact" className="text-white-50 text-decoration-none">
                  <i className="fas fa-chevron-right me-2 text-warning"></i>
                  Contact
                </Link>
              </li>
            </ul>
          </Col>
          
          <Col lg={3} md={4} className="mb-4">
            <h5 className="text-white mb-4">Important Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="#" className="text-white-50 text-decoration-none">
                  <i className="fas fa-external-link-alt me-2 text-warning"></i>
                  NAAC Accreditation
                </Link>
              </li>
              <li className="mb-2">
                <Link to="#" className="text-white-50 text-decoration-none">
                  <i className="fas fa-external-link-alt me-2 text-warning"></i>
                  IQAC
                </Link>
              </li>
              <li className="mb-2">
                <Link to="#" className="text-white-50 text-decoration-none">
                  <i className="fas fa-external-link-alt me-2 text-warning"></i>
                  Anti-Ragging
                </Link>
              </li>
              <li className="mb-2">
                <Link to="#" className="text-white-50 text-decoration-none">
                  <i className="fas fa-external-link-alt me-2 text-warning"></i>
                  RTI
                </Link>
              </li>
              <li className="mb-2">
                <Link to="#" className="text-white-50 text-decoration-none">
                  <i className="fas fa-external-link-alt me-2 text-warning"></i>
                  Grievance Redressal
                </Link>
              </li>
            </ul>
          </Col>
          
          <Col lg={3} md={4} className="mb-4">
            <h5 className="text-white mb-4">Contact Info</h5>
            <ul className="list-unstyled">
              <li className="mb-3 d-flex align-items-start">
                <i className="fas fa-map-marker-alt text-warning mt-1 me-2"></i>
                <span className="text-white-50">
                  College Road,<br />
                  City Name,<br />
                  State - 123456
                </span>
              </li>
              <li className="mb-3 d-flex align-items-center">
                <i className="fas fa-phone text-warning me-2"></i>
                <span className="text-white-50">+91 12345 67890</span>
              </li>
              <li className="mb-3 d-flex align-items-center">
                <i className="fas fa-envelope text-warning me-2"></i>
                <span className="text-white-50">info@college.edu</span>
              </li>
              <li className="d-flex align-items-center">
                <i className="fas fa-clock text-warning me-2"></i>
                <span className="text-white-50">Mon-Fri: 9:00 AM - 5:00 PM</span>
              </li>
            </ul>
          </Col>
        </Row>
        
        <hr className="bg-white-50 my-4" />
        
        <Row>
          <Col className="text-center">
            <p className="mb-2 text-white-50">
              © {currentYear} University College. All Rights Reserved.
            </p>
            <p className="mb-0 text-white-50">
              Designed with <i className="fas fa-heart text-danger mx-1"></i> by College Team
            </p>
            <div className="mt-2">
              <Link to="/privacy" className="text-white-50 text-decoration-none me-3">
                Privacy Policy
              </Link>
              <span className="text-white-50">|</span>
              <Link to="/terms" className="text-white-50 text-decoration-none ms-3">
                Terms of Use
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
      
      <style jsx="true">{`
        .social-links .btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 5px 15px rgba(0,0,0,0.3);
        }
        
        footer a:hover {
          color: #ffc107 !important;
          text-decoration: underline !important;
        }
        
        .social-links .btn {
          transition: all 0.3s ease;
        }
      `}</style>
    </footer>
  );
};

export default Footer;